/** Hero CTA text that opens the location picker (Contentful Capsule Hero). */
export const HERO_LOCATION_PICKER_CTA_TEXT = "Choose your location"

export function isHeroLocationPickerCtaText(
  ctaText: string | null | undefined
): boolean {
  if (ctaText == null || ctaText === "") return false
  return ctaText.trim() === HERO_LOCATION_PICKER_CTA_TEXT
}
